// store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import { rootReducer } from "./rootReducer";
import TENANT_ID from "./tenantId";

const createMemoryStorage = () => {
  const store = new Map();
  return {
    getItem(key) {
      return Promise.resolve(store.get(key) ?? null);
    },
    setItem(key, value) {
      store.set(key, value);
      return Promise.resolve(value);
    },
    removeItem(key) {
      store.delete(key);
      return Promise.resolve();
    },
  };
};

const createSafeLocalStorage = () => {
  if (typeof window === "undefined") return createMemoryStorage();
  try {
    const testKey = "__redux_persist_test__";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    return createWebStorage("local");
  } catch {
    return createMemoryStorage();
  }
};

const storage = createSafeLocalStorage();

const persistConfig = {
  key: `root4:${TENANT_ID}`,
  version: 1,
  storage,
  whitelist: ["user", "config"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

const persistor = persistStore(store);

export { store, persistor };
